import { useState } from 'react';
import { BUCKET_LABEL, speedMapRows, type BetClass, type MapRow, type SpeedMap as SpeedMapData } from './lib';
import { useTrack } from '../track';

function Bar({ r }: { r: MapRow }) {
  return (
    <li className={r.pick ? `pkn ${r.pick}` : ''}>
      <span className="bn" aria-label={`Barrier ${r.barrier ?? 'unknown'}`}>
        {r.barrier ?? '–'}
      </span>
      <span className="bw">
        <i className="fill" style={{ width: `${r.width}%` }} aria-hidden="true" />
        <span className="h">
          <b>{r.tab}</b> {r.horse}
        </span>
      </span>
      <small className="bk">{BUCKET_LABEL[r.bucket] ?? r.bucket}</small>
    </li>
  );
}

/** Where each runner should settle: one line per runner, the longer its bar the further forward. Our picks take their bet colour. */
export function SpeedMap({ map, picks, raceNumber }: { map: SpeedMapData; picks: Map<number, BetClass>; raceNumber?: number }) {
  const [sort, setSortState] = useState<'barrier' | 'settle'>('barrier');
  const track = useTrack();
  const setSort = (v: 'barrier' | 'settle') => {
    setSortState(v);
    track('ui_toggle', { control: 'speed_map_order', value: v, raceNumber });
  };
  const { byBarrier, bySettle, unknown } = speedMapRows(map, picks);
  const rows = sort === 'barrier' ? byBarrier : bySettle;
  return (
    <div className="ui-sm">
      <div className="smt">
        {map.likelyTempo && <span className="tempo">{map.likelyTempo} pace</span>}
        <div className="sbs" role="group" aria-label="Sort the speed map">
          <button type="button" aria-pressed={sort === 'barrier'} onClick={() => setSort('barrier')}>
            Barrier
          </button>
          <button type="button" aria-pressed={sort === 'settle'} onClick={() => setSort('settle')}>
            Settling
          </button>
        </div>
      </div>
      {map.tempoRationale && <p className="smh">{map.tempoRationale.replace(/->/g, '→')}</p>}
      <ol className="sbr">
        {rows.map((r) => (
          <Bar key={r.tab} r={r} />
        ))}
      </ol>
      {unknown.length > 0 && (
        <div className="sml">
          <span className="k">Unknown</span>
          <span className="nms">
            {unknown.map((u) => (
              <span key={u.tab}>
                <b>{u.tab}</b> {u.horse}
              </span>
            ))}
          </span>
        </div>
      )}
      <div className="src">Our picks are coloured by bet type.</div>
    </div>
  );
}
